import React from 'react';
import { BaasicInput } from 'core/components';
import { translate, selectLogo } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

const PasswordRecoveryChangeTemplate = ({ currentView: { passwordRecoveryChangeForm, goToLogin }, t }) => {
	var logo_show = selectLogo();
	return (
		<section className="w--400--px align--h--center padd--top--med">
			<img className="w--200--px display--b align--h--center spc--bottom--med" src={logo_show} alt="Logo" />
			<form className="form box--primary box--med" onSubmit={passwordRecoveryChangeForm.onSubmit}>
				<h3 className="spc--bottom--sml">{t('NEWPASSWORD')}</h3>
				<BaasicInput field={passwordRecoveryChangeForm.$('password')} className="fs-mask" showCheckmark={false} />
				<BaasicInput field={passwordRecoveryChangeForm.$('confirmPassword')} className="fs-mask" showCheckmark={false} />
				{passwordRecoveryChangeForm.error && (
					<div>
						<p className="type--color--warning">{translate(form.error)}</p>
					</div>
				)}
				<div className="group spc--top--sml">
					<button className="btn btn--med btn--primary  pull" type="submit">
						{t('SUBMIT')}
					</button>
					<a className="btn btn--med btn--ghost push" onClick={goToLogin}>
						{t('GOBACKTOLOGIN')}
					</a>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(PasswordRecoveryChangeTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/membership/pages/PasswordRecoveryChangeTemplate.jsx